import React from 'react'

function AppTermCondition() {
  return (
  

      <div className="privacy-container">

    

          <div className="privacy-header">
     
        <h1>Bhumu Company</h1>

 <p> Legal Documents </p>
 <p> Privacy Policy  |  Terms of Service </p>
 <p> Effective Date: April 11, 2025 </p>

<br/>
<p> These documents govern your use of the Bhumu Company mobile application. Please read them carefully before using the App.</p>




 <br/><br/>


<h4> PART I</h4>

<h2>  Privacy Policy</h2>
<p> This Privacy Policy governs the collection, use, and protection of personal information by Bhumu Company through its mobile application ("the App"). The App enables users to book home services including bike servicing, AC repair, and pet grooming.  By using the App, you acknowledge that you have read and understood this Privacy Policy. Your consent to data collection is obtained explicitly within the App before any personal data is processed. You may deny consent, though doing so may limit access to certain features.</p>
  
   
      </div>







        <div className="privacy-section">
        <h3>  1. User Consent</h3>
        <p>
            Before collecting any personal data, the App presents a clear consent screen that explains what data is collected and why, allows you to grant or deny consent, and informs you that denying consent may restrict features such as service booking and provider assignment. Consent can be updated or withdrawn at any time through App Settings.
        </p>
        <p>
No personal data is collected, stored, or processed until you provide explicit consent.
        </p>
      </div>



        <div className="privacy-section">

<h3> 2. Data We Collect, When, and Why </h3>

<p> We collect only the data strictly necessary to provide our home services.</p>
</div>




 <div className="privacy-section">
<h3>2a. Full Name</h3>
 <p>When collected: During account registration. </p>
 <p>Why collected: To identify the account holder, personalize the user experience, and communicate service updates.</p>
</div>


 <div className="privacy-section">

<h3>2b. Phone Number</h3>
 <p>When collected: During OTP-based account registration and login.</p>
 <p>Why collected: To verify user identity via One-Time Password (OTP) authentication, and to contact the user regarding booking confirmations, service updates, and support.</p>

</div>





 <div className="privacy-section">


<h3>2c. Email Address</h3>
 <p>When collected: Optionally during account registration.</p>
 <p>Why collected: To send booking receipts, service summaries, and account-related notifications.</p>

</div>


<div className="privacy-section">



 <h3>2d. Device Location (Foreground Only)</h3>
 <p>When collected: Only while the App is actively open and in use (foreground).</p>
 <p>Why collected: To determine which services are available in your area and to assign the nearest qualified service professional to your booking.</p>
 <p>Background: We do NOT collect location data when the App is closed or running in the background. Location access is automatically terminated when the App leaves the foreground.</p>
 <p>Permission: You may deny location permission via your device settings. If denied, service availability lookup and provider assignment will not function.</p>
</div>



<div className="privacy-section">


 <h3>3. Firebase Analytics</h3>
 <p>The App uses Google Firebase Analytics to understand how users interact with the App, identify technical issues, and improve overall performance. Firebase Analytics is disabled by default and is only enabled after you grant explicit consent at app launch.</p>
 <p>When enabled, Firebase Analytics collects:</p>
 <ul>
   <li>Screen views and navigation patterns</li>
   <li>App session duration and frequency</li>
   <li>Device model and operating system version</li>
 </ul>
 <p>General crash and error reports</p>
 <p>You may disable Firebase Analytics at any time through App Settings. Firebase operates under Google's Privacy Policy: https://policies.google.com/privacy</p>
</div>


<div className="privacy-section">

<h3>4. How We Share Your Data</h3>
 <p>We do not sell, rent, trade, or license your personal data to any third party for commercial purposes. We do not display advertisements and we do not share your data with advertising networks or data brokers.</p>
 
 </div>


 <div className="privacy-section">
 <h3>4a. Service Professionals</h3>
 <p>Your name, phone number, and approximate location are shared with the assigned service professional solely to complete your booked service. Service professionals are contractually prohibited from using your data for any other purpose.</p>
 </div>




  <div className="privacy-section">

 
 <h3>4b. Legal Obligations</h3>
 <p>We may disclose your personal data if required by applicable law, court order, or government authority, or to protect the rights, property, or safety of Bhumu Company, its users, or the public.</p>
</div>





<div className="privacy-section">


<h3>4c. Firebase / Google</h3>


 <p>  Usage analytics data is processed by Google Firebase only after user consent and is governed by Google's data processing terms.
</p>

</div>



<div className="privacy-section">
<h3>5. Your Rights and Choices</h3>
<h4>5a. Access and Correction</h4>
<p>You may review and update your name, phone number, and email address at any time through Account Settings.</p>
</div>



<div className="privacy-section">

    

<h3>5b. Account and Data Deletion</h3>
<p>You may request deletion of your account and all associated personal data by emailing info@bhumucompany.com or using the Delete Account option in App Settings. Requests are processed within 30 days. Booking history required for legal compliance may be retained for up to 90 days before permanent deletion.</p>


</div>



<div className="privacy-section">

<h3>5c. Withdraw Consent</h3>
<p>You may withdraw consent for data collection or analytics at any time through Privacy Settings. This stops all future data collection but does not affect processing carried out before withdrawal.</p>

<h3>5d. Location Permission</h3>
<p>You may revoke location access at any time through your device's system settings. The App does not request permanent or background location access.</p>

</div>


<div className="privacy-section">

<h3>6. Data Retention</h3>
  <li> Account data (name, phone, email): Retained for the duration of the active account. Deleted within 30 days of an account deletion request. </li>
  <li> Booking history: Retained for 90 days after service completion for dispute resolution and legal compliance, then permanently deleted.  </li>
  <li> Location data: Not stored persistently. Used in real time during active sessions only and not logged or retained after the session ends. </li>
  <li> Analytics data: Retained by Google Firebase per their data retention policy. You may opt out at any time. </li>



</div>



<div className="privacy-section">
<h3>7. Data Security</h3>
<p>We implement the following measures to protect your personal information:</p>
<ul>
  <li>Encrypted data transmission using HTTPS/TLS for all communications between the App and our servers</li>
  <li>Firebase Authentication for secure OTP-based login, managed by Google</li>
  <li>Access controls restricting user data to authorized personnel only</li>
</ul>



<p>Regular review of our data collection and security practices
While we take reasonable precautions to protect your data, no method of electronic transmission or storage is completely secure. We cannot guarantee absolute security of your personal information.


</p></div>



<div className="privacy-section"> 



<h3>8. Third-Party Services</h3>
The App integrates Google Firebase (Authentication and Analytics), used for OTP-based login and usage analytics. This service is operated by Google LLC under its own Privacy Policy and Terms of Service: https://firebase.google.com/support/privacy  We do not integrate advertising SDKs, third-party data brokers, or social media tracking tools.




</div>




<div className="privacy-section">
<h3>9. Children's Privacy</h3>
<p>The App is not intended for use by individuals under the age of 13. We do not knowingly collect personal information from children under 13. If we become aware that such data has been collected without verifiable parental consent, we will delete it within 30 days. To report a concern, contact us at info@bhumucompany.com.</p>

</div>



<div className="privacy-section">
<h3>10. Changes to This Privacy Policy</h3>
<p>We may revise this Privacy Policy periodically. When material changes are made, we will notify you through an in-app notification or email before the change becomes effective. Continued use of the App after the effective date constitutes acceptance of the updated policy.</p>
</div>

<div className="privacy-section">
<h3>11. Contact Us (Privacy)</h3>
<p>If you have questions, concerns, or requests relating to this Privacy Policy or your personal data, please contact us at:  Bhumu Company Email: info@bhumucompany.com  We will respond to all privacy-related requests within 30 days.</p>
</div>
   


   




          <div className="privacy-header">


    <h4> PART II</h4>

<h2>  Terms of Service</h2>


<p> These Terms of Service ("Terms") govern your access to and use of the Bhumu Company mobile application ("the App") and all related services provided by Bhumu Company ("we", "us", or "our"). By creating an account or using the App, you agree to be bound by these Terms. If you do not agree, do not use the App.</p>
</div>



<div className="privacy-section">


<h3>1. Eligibility</h3>
<p>You must be at least 18 years of age to use the App and book services. By using the App, you represent and warrant that you are 18 years of age or older, have the legal capacity to enter into a binding agreement, and are not prohibited from using the App under any applicable law.</p>


</div>











<div className="privacy-section">



<h3>2. Account Registration</h3>
  <p> You must register an account using a valid phone number. Account creation requires OTP (One-Time Password) verification.</p>
  <p> You are responsible for maintaining the confidentiality of your account and all activity that occurs under it.</p>
  <p> You agree to provide accurate, current, and complete information during registration and to update it as necessary.</p>
  <p> You must not create an account on behalf of another person without their explicit consent, or for any fraudulent purpose.</p>
  <p> We reserve the right to suspend or terminate your account if any information provided is found to be inaccurate, misleading, or in violation of these Terms.</p>


</div>






<div className="privacy-section">



 <h3>3. Services Offered</h3>
The App enables users to book the following home services:
  <li> Bike servicing and repair </li>
  <li> AC installation, repair, and maintenance </li>
  <li> Pet grooming  </li>
Bhumu Company acts as a platform connecting users with independent service professionals. We do not directly employ service professionals. Availability of services may vary based on your location. We reserve the right to add, modify, or discontinue any service at any time without prior notice.


</div>


<div className="privacy-section">

<h3>4. Bookings and Orders</h3>
<p>Placing a Booking </p>
<p>When you submit a service booking through the App, you are making a request for a service. A booking is confirmed only when you receive a confirmation notification from the App.  </p>
<p>Cancellations  </p>
<p>You may cancel a confirmed booking through the App before the service professional is assigned or has commenced travel. Once a professional is en route or on-site, cancellations may be subject to a cancellation fee as communicated at the time of booking.  </p>
<p>Rescheduling  </p>
<p>You may reschedule a booking subject to professional availability. Rescheduling requests must be made at least 2 hours before the scheduled service time.  </p>
<p>No-Shows  </p>
<p>If you are unavailable at the time of service without prior notice, the booking may be marked as a no-show and a fee may apply.   </p>

</div>



<div className="privacy-section">

<h3> Payments </h3> 
<ul>
  <li> All service fees are displayed in the App before you confirm a booking.  </li>
  <li> Payments are processed securely through the App. We do not store your payment card details on our servers.  </li>
  <li> Prices are subject to change. Any price change will be communicated before booking confirmation. </li>
  <li> Refunds, if applicable, will be processed within 7 business days to the original payment method. </li>
  <li> You are responsible for any applicable taxes or government-mandated charges in your jurisdiction. </li>
</ul>

</div>



<div className="privacy-section">
<h3>6. User Responsibilities</h3>
<p> By using the App, you agree to: </p>
<ul>
  <li>Use the App only for lawful purposes</li>
  <li>Treat service professionals with respect. Any abusive, threatening, or discriminatory behavior will result in account suspension</li>
  <li>Provide accurate service location information to ensure timely and correct service delivery</li>
  <li>Not attempt to contact or hire service professionals outside the App to bypass platform fees</li>
  <li>Not use the App to post false reviews, manipulate ratings, or engage in fraudulent activity</li>
  <li>Not attempt to reverse-engineer, copy, or exploit any part of the App or its infrastructure</li>
</ul>

</div>




<div className="privacy-section">
<h3>7. Service Professional Conduct</h3>
<p>Service professionals available through the App are independent contractors, not employees of Bhumu Company. While we verify and vet professionals before onboarding, we do not guarantee the quality, safety, or outcome of any service. Any disputes arising from the conduct of a service professional must be reported to us at info@bhumucompany.com within 48 hours of service completion.</p>
</div>

<div className="privacy-section">
<h3>8. Ratings and Reviews</h3>
<p>After a service is completed, you may be invited to rate and review the service professional. Reviews must be honest, based on your genuine experience, and must not contain defamatory, abusive, or illegal content. We reserve the right to remove reviews that violate these guidelines.</p>
</div>

<div className="privacy-section">
<h3>9. Intellectual Property</h3>
<p>All content within the App, including but not limited to text, graphics, logos, icons, images, and software, is the exclusive property of Bhumu Company and is protected under applicable intellectual property laws. You may not copy, reproduce, distribute, or create derivative works from any part of the App without our prior written consent.</p>
</div>

<div className="privacy-section">
<h3>10. Limitation of Liability</h3>
<p>To the maximum extent permitted by applicable law, Bhumu Company shall not be liable for: </p>
<ul>
  <li>Any indirect, incidental, special, or consequential damages arising from your use of the App or any service booked through it</li>
  <li>Loss or damage to property during service delivery caused by an independent service professional</li>
  <li>Service interruptions, delays, or cancellations beyond our reasonable control</li>
  <li>Any losses resulting from unauthorized access to your account due to your failure to maintain account security</li>
</ul>
<p>Our total liability to you for any claim arising from the use of the App shall not exceed the amount you paid for the specific service in question.</p>

</div>

<div className="privacy-section">
<h3>11. Disclaimer of Warranties</h3>
<p>The App and all services are provided on an "as is" and "as available" basis without warranties of any kind, either express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, or non-infringement. We do not warrant that the App will be uninterrupted, error-free, or free of viruses or other harmful components.</p>
</div>

<div className="privacy-section">
<h3>12. Indemnification</h3>
<p>You agree to indemnify, defend, and hold harmless Bhumu Company, its officers, directors, employees, and agents from and against any claims, liabilities, damages, losses, or expenses (including legal fees) arising from your use of the App, your violation of these Terms, or your violation of any rights of another person or entity.</p>
</div>

<div className="privacy-section">
<h3>13. Account Termination</h3>
<p>By You</p>
<p>You may delete your account at any time through App Settings or by contacting info@bhumucompany.com. Upon deletion, your personal data will be removed within 30 days as described in our Privacy Policy.</p>
<p>By Us</p>
<p>We reserve the right to suspend or permanently terminate your account without prior notice if you violate these Terms, engage in fraudulent or abusive behavior, or if required to do so by law.</p>
</div>

<div className="privacy-section">
<h3>14. Governing Law and Disputes</h3>
<p>These Terms are governed by and construed in accordance with the laws of India. Any disputes arising from or related to these Terms or the use of the App shall be subject to the exclusive jurisdiction of the courts located in India.  Before initiating any legal proceedings, you agree to attempt to resolve any dispute informally by contacting us at info@bhumucompany.com. We will make reasonable efforts to resolve disputes within 30 days.</p>
</div>


<p> Both documents are effective as of April 11, 2025 and apply to all users of the Bhumu Company App.</p>


   </div>
   
  )
}

export default AppTermCondition